import type { PartDefinition } from "./types";
import { generateCatalogParts } from "./partsCatalog";

export const PARTS: PartDefinition[] = generateCatalogParts();

export const PART_BY_ID = Object.fromEntries(
  PARTS.map((p) => [p.id, p]),
) as Record<string, PartDefinition>;

export const STARTER_PART_IDS = PARTS.filter((p) => p.starter).map((p) => p.id);

export const SHOP_PARTS = PARTS.filter((p) => p.starCost !== undefined);

export const SHOP_PART_TOTAL_COST = SHOP_PARTS.reduce(
  (sum, p) => sum + (p.starCost ?? 0),
  0,
);

export const PART_COUNT = PARTS.length;
